"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = CornerTriangle;
var _CornerTriangle = require("@adobe/react-spectrum-ui/dist/CornerTriangle.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function CornerTriangle(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_CornerTriangle.CornerTriangle, null));
}